import type { FirestoreQuery } from '@shared/types';

function formatFilterValue(value: unknown): string {
  if (typeof value === 'string') return `"${value}"`;
  if (Array.isArray(value)) {
    const parts = value.map((v) => (typeof v === 'string' ? `"${v}"` : String(v)));
    return `[${parts.join(', ')}]`;
  }
  return String(value);
}

export function generateQueryPreviewCode(query: FirestoreQuery, collectionName: string): string {
  const lines: string[] = [];
  lines.push(`const q = query(`);
  lines.push(`  collection(db, "${collectionName}"),`);

  if (query.filters && query.filters.length > 0) {
    query.filters.forEach((filter) => {
      const valueStr = formatFilterValue(filter.value);
      lines.push(`  where("${filter.field}", "${filter.operator}", ${valueStr}),`);
    });
  }

  if (query.orderBy && query.orderBy.length > 0) {
    query.orderBy.forEach((order) => {
      lines.push(`  orderBy("${order.field}", "${order.direction}"),`);
    });
  }

  if (query.limit) {
    lines.push(`  limit(${query.limit})`);
  }

  lines.push(`);`);
  return lines.join('\n');
}
